/**
 * Countries the Hapana Capital programme is offered in today (OC-898).
 *
 * Stripe supports Capital for connected accounts in US, GB, FR, DE and AU; we are deliberately
 * launching into AU and US only and will widen this list as each further market is signed off —
 * adding a code here is the whole change. Shared so the nav gate and the account-session guard
 * can never disagree about who is eligible.
 */
export const CAPITAL_SUPPORTED_COUNTRIES = ['AU', 'US'] as const

/** Whether the Capital programme has launched in this location's country. */
export const isCapitalSupportedCountry = (countryCode?: string | null): boolean =>
  Boolean(
    countryCode &&
    (CAPITAL_SUPPORTED_COUNTRIES as readonly string[]).includes(countryCode.toUpperCase())
  )
